import { SignedIn, SignedOut, SignIn } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";

export default function LoginPage() {
  return (
    <div className="center">
      <SignedIn>
        <Navigate to="/" replace />
      </SignedIn>
      <SignedOut>
        <div>
          <h1 className="brand">org-user-sync</h1>
          <SignIn routing="hash" />
        </div>
      </SignedOut>
    </div>
  );
}
